import * as React from 'react';
import { useGoBack } from '@leagueplatform/web-common';
import { BackButtonArrow } from '@leagueplatform/web-common-components';

type BackButtonProps = { fallbackLocation: string };

export function BackButton({ fallbackLocation }: BackButtonProps) {
  const goBack = useGoBack(fallbackLocation);

  return (
    <BackButtonArrow
      onClick={(event: React.MouseEvent) => {
        event.preventDefault();
        goBack();
      }}
      as="a"
      href="#"
      id="go-back"
    />
  );
}
